module.exports = "/shiftTasks/components/taskTemplates/modalTaskInstanceDeleteConfirm-f19538.html";